import React from "react";
import { Form, Input, Button, Card, message, Typography } from "antd";
import { Mail, Lock, UserPlus } from "lucide-react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import useUserStore from "../store/userStore";

const { Title, Text } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useUserStore();
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect") || "/";

  // 组件加载时清除错误状态
  React.useEffect(() => {
    clearError();
  }, [clearError]);

  const onFinish = async (values) => {
    const { email, password } = values;
    const result = await login(email, password);
    if (result.success) {
      message.success("登录成功");
      navigate(redirectUrl);
    } else {
      message.error(result.error);
    }
  };

  return (
    <div
      key="login"
      className="min-h-screen flex items-center justify-center bg-gray-50 p-4"
    >
      <Card className="w-full max-w-md shadow-lg" bordered={false}>
        <div className="text-center mb-6">
          <Title level={3} className="mb-2">
            欢迎登录
          </Title>
          <Text type="secondary">体验新一代AI技术</Text>
        </div>

        <Form
          form={form}
          name="login"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ remember: true }}
        >
          <Form.Item
            name="email"
            label="邮箱"
            rules={[
              { required: true, message: "请输入您的邮箱" },
              { type: "email", message: "请输入有效的邮箱地址" },
            ]}
          >
            <Input
              prefix={<Mail className="text-gray-400" size={16} />}
              placeholder="请输入邮箱"
              className="h-11"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="密码"
            rules={[
              { required: true, message: "请输入您的密码" },
              { min: 6, message: "密码长度不能少于6位" },
            ]}
          >
            <Input.Password
              prefix={<Lock className="text-gray-400" size={16} />}
              placeholder="请输入密码"
              className="h-11"
              visibilityToggle
            />
          </Form.Item>

          <Form.Item className="mb-6">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full h-11 text-base"
              loading={isLoading}
              size="large"
            >
              登录
            </Button>
          </Form.Item>

          <div className="text-center">
            <Text type="secondary" className="flex items-center justify-center">
              还没有账号？
              <Link
                to="/register"
                className="text-blue-600 hover:text-blue-800 font-medium flex items-center"
              >
                <UserPlus size={14} className="inline mr-1" /> 立即注册
              </Link>
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
